"use client";

import type { QueueContentType } from "../../../lib/types/enums/queue/queueContentTypeEnum";
import { queueSchema } from "../../../lib/types/schema/queue/queueSchema";
import type { UseRequestProps } from "../../../request/hooks/useRequest";
import { useRequest } from "../../../request/hooks/useRequest";

export type UseRequestQueueProps = UseRequestProps;

export const useRequestQueue = ({ ...props }: UseRequestQueueProps = {}) => ({
  requestPut: useRequest({
    ...props,
    fnRequestProps: (data: {
      content: Array<{
        content_id: number;
        content_type: QueueContentType;
      }>;
      current_item_index: number;
    }) => ({
      body: JSON.stringify(data),
      method: "PUT",
      schema: queueSchema,
      urlBackendPath: "/queue",
    }),
  }),
});
